<template>
  <div class="flex items-center gap-2">
    <hr class="flex-1 border-dashed border-gray-200" />
    <span class="text-xs text-gray-400 uppercase tracking-wide">
      {{ t('product.show.noDates.or') }}
    </span>
    <hr class="flex-1 border-dashed border-gray-200" />
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>
